import React, { useEffect } from "react";
import { pubCall } from "../utils/PubSub";
import { KBD } from "../utils/Keybindings";
import Alert from "../ui/Alert";
import dayjs from "dayjs";
import { ROUTES } from "../utils/Routes";
import Cookies from "js-cookie";
import TextButton from "../ui/TextButton";
export default function Maintenance(props) {
    const { route = "", callback = () => { } } = props;

    useEffect(() => {

        if (!window.bm_state.value === ROUTES.GLOBAL.MAINTENANCE) {
            return;
        }
        const intervalId = setInterval(() => {
            pubCall("extra.ping", { time: dayjs().unix() }, () => { });
        }, 30000); // Update every second
        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);

    const changeLocation = () => {
        Cookies.set("workstation", null, { expires: 14 })
        window.history.replaceState(null, '', '/');
        window.location.reload();
    }

    // Backup is in queue/processing 
    // Store is in maintenance mode
    // Store removed from processing

    let notice = <>Bookmanager is currently set to <strong>maintenance mode</strong>, and all current functions are temporarily unavailable. <div className="shim" /><div className="shim" /><div className="shim" /></>;


    let color = "var(--text-orange)";
    let message;
    let header = "Maintenance mode.";
    switch (props.res?.kwargs?.message) {

        case "Need to update bm":
            notice = "";
            header = "Update required.";
            color = "var(--text-purple)";
            message = <>Your Bookmanager software is out of date. In order to use BMO, you will need to update your Bookmanager software and send a new backup.<div className="shim" /><div className="shim" />Please contact support if you require assistance.<div className="shim" /><div className="shim" /><div className="shim" /></>;
            break;

        case "Backup is in queue/processing":
            color = "var(--text-olive)"
            notice = <>A backup from your Bookmanager software was recently sent and is currently being processed. During this time, all functions in BMO are temporarily unavailable.</>
            message = <>It may take up to 45 minutes for your backup to be processed and BMO to resume operations. Once we finish processing your backup, access to BMO will automatically resume.<div className="shim" /><div className="shim" />You may want to check your Bookmanager software's Scheduler to see if additional backup routines are set to run in the near future, and postpone those instances if you need BMO access during those times.<div className="shim" /><div className="shim" /><div className="shim" /></>;

            break;
        case "Store is in maintenance mode":
            color = "var(--text-orange)"
            message = <>Oh no, something seems to have gone wrong! Please send a backup in order to use BMO again. If this keeps happening, please contact Bookmanager support for assistance. <div className="shim" /><div className="shim" /><div className="shim" /></>;

            break;
        case "Store removed from processing":
            color = "var(--text-red)"
            message = <>Oh shoot, something went wrong! Please contact Bookmanager support to help resolve this issue. <div className="shim" /><div className="shim" /><div className="shim" /></>;
            break;

        case "Store weblink not connected":
            header = "Weblink not connected"
            color = "var(--text-blue)"
            notice = <>Weblink seems to be disconnected. Please check your Bookmanager server station and ensure that weblink is setup and connected. <div className="shim" /><div className="shim" />This message will clear once BMO detects your weblink is connected again. For assistance, please contact support.<div className="shim" /><div className="shim" /><div className="shim" /></>;
            break;


        default:

    }

    const stores = window?.sitesettings?.available_corps?.filter(item => item.can_bmo) || [];

    return (
        <div style={{ "width": "500px" }}>
            <div className="shim" /><div className="shim" />
            <Alert
                color={color}
                title={header}
                description={<>{notice}{message}
                    {(stores.length > 1 &&
                        <TextButton kbd={KBD.ESCAPE} onClick={() => changeLocation()} disabled type="secondary">Change Location</TextButton>
                    )}
                </>}
            />
        </div>
    )


}
